import React, { useState, useEffect } from 'react';
import ContainerLoaderCharts from '../logistica/Charts/ContainerLoaderCharts';
import stilePulsanti from '../interfaccia/stilePulsanti';
import SettingBooleano from './SettingBooleano';

function StatSpedMotiviAnnullamenti({
  mobile
}) {
  
    const {
        buttonClassesWhite,
        buttonClassesGreen,
        buttonClassesOrange,
        buttonClassesRed
    } = stilePulsanti


    const [settings, setSettings] = useState({
        series: {
            magazzino: true,
            annullato: true,
            no_pagamento: true,
            destinatario: true,
            fuoriUE: true,
            err_pagamento: true,
            mancanza_tempo: true
        },        
        anni: 3,
        robaDaSommare: "importo",
        ancheSpediti: 0,
        stack: 1
    })



  return (
    
        <div className='sfondoBiancoTema tc pa3'>
        <h3>Grane sugli ordini all-time</h3>
            <div className='flex items-center justify-center'>
                <div>ultimi</div>
            <input
                type='number'
                value={settings.anni}
                onChange={(e)=>setSettings({...settings,anni:e.target.value})}
                className={stilePulsanti.inputClassesRicercaOrizzontale}
                min={1}
                max={10}
            />
            <div className='mr4'>anni</div>
            {Object.keys(settings.series).map((mp)=><SettingBooleano 
                value={settings.series[mp]}
                    trueButtonClass={buttonClassesGreen}
                    falseButtonClass={buttonClassesWhite}
                    trueElement={mp}
                    falseElement={mp}
                    setTrue={()=>setSettings({...settings,series:{...settings.series, [mp]: true}})}
                    setFalse={()=>setSettings({...settings,series:{...settings.series, [mp]: false}})}
            />)}
            <div className='ml4 mr3'>importo ordini/numero ordini</div>
            <SettingBooleano 
                value={settings.robaDaSommare}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesGreen}
                    trueElement={"importo"}
                    falseElement={"ordini"}
                    setTrue={()=>setSettings({...settings,robaDaSommare:"importo"})}
                    setFalse={()=>setSettings({...settings,robaDaSommare:"ordini"})}
                    customValueTrue={"importo"}
                    customValueFalse={"ordini"}
            />
            <div className='ml4 mr3'>stack / linee</div>
            <SettingBooleano 
                value={settings.stack}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesGreen}
                    trueElement={"stack"}
                    falseElement={"linee"}
                    setTrue={()=>setSettings({...settings,stack:1})}
                    setFalse={()=>setSettings({...settings,stack:0})}
            />
            <div className='ml4 mr3'>annullati / tutti</div>
            <SettingBooleano 
                value={settings.ancheSpediti}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesRed}
                    trueElement={"tutti"}
                    falseElement={"annullati"}
                    setTrue={()=>setSettings({...settings,ancheSpediti:1})}
                    setFalse={()=>setSettings({...settings,ancheSpediti:0})}
            />
            </div>          
            <ContainerLoaderCharts 
                query={`/contab/charts/linesSpedizioniAnnullate?`+ new URLSearchParams({anni: settings.anni, robaDaSommare: settings.robaDaSommare, ancheSpediti: settings.ancheSpediti})}
                titolo=""
                tipo ="linesSpedizioniAnnullate"
                displayTitolo={false}
                settings={settings}
            />
        </div>
  )
}

export default StatSpedMotiviAnnullamenti;
